/*! Basic Scripts 27.05.2025 */


/*----------------------------------------
  Shrinking Header
----------------------------------------*/
document.addEventListener('DOMContentLoaded', function() {
    // Header "shrink"-Effekt beim Scrollen
    const header = document.querySelector('header');

    if (header) {
        window.addEventListener('scroll', function() {
            if (window.scrollY > 30) {
                header.classList.add('shrink');
            } else {
                header.classList.remove('shrink');
            }
        });
    }
});


/*----------------------------------------
  Top-Link
----------------------------------------*/
document.addEventListener('DOMContentLoaded', function() {
    // Toplink-Button anzeigen/verstecken
    const toplinkButton = document.getElementById('toplink-button');

    if (toplinkButton) {
        window.addEventListener('scroll', function() {
            toplinkButton.classList.toggle('toplink-button--active', window.scrollY > 300);
        });

        // Klick-Ereignis für sanftes Scrollen nach oben
        toplinkButton.addEventListener('click', function(e) {
            e.preventDefault();
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        });
    }
});


/*----------------------------------------
  Send form succeed
----------------------------------------*/
document.addEventListener("DOMContentLoaded", function () {
  const ButtonSendSucceed = document.getElementById("SendButton-succeed");
  if (ButtonSendSucceed) {
    ButtonSendSucceed.addEventListener("click", function () {
      location.reload(true);
    });
  }
});


/*----------------------------------------
  Navbar Mobile Toggler
----------------------------------------*/
function initializeNavMobile() {
  const navSelector = '.nav--mobile'; // Fester Selektor für das Hauptnavigationselement
  const togglerSelector = '.navbar-toggler'; // Fester Selektor für das Toggler-Element

  let mainNavElement = document.querySelector(navSelector);
  let togglerElement = document.querySelector(togglerSelector);

  // Wichtig: Prüfen, ob die Elemente existieren, bevor wir fortfahren.
  if (!mainNavElement) {
    // console.warn(`NavMobile: Das Hauptelement "${navSelector}" wurde nicht gefunden.`);
    return; // Funktion beenden, wenn das Hauptelement fehlt
  }
  if (!togglerElement) {
    // console.warn(`NavMobile: Das Toggler-Element "${togglerSelector}" wurde nicht gefunden.`);
    return; // Funktion beenden, wenn der Toggler fehlt
  }

  let submenuItems = mainNavElement.querySelectorAll("li.submenu");
  let activeTrailSubmenus = mainNavElement.querySelectorAll("li.submenu.active,li.submenu.trail");
  let isTouch = false;

  function toggleActiveTrailSubmenus() {
    activeTrailSubmenus.forEach(item => {
      item.classList.toggle("submenu--active", null !== togglerElement.offsetParent || item.parentNode.classList.contains("level_2"));
    });
  }

  window.addEventListener("touchstart", function() {
    isTouch = true;
  });

  togglerElement.addEventListener("click", function() {
    mainNavElement.classList.toggle("nav--mobile--active");
    togglerElement.classList.toggle("navbar-toggler--active"); // Ersetzt
  });

  toggleActiveTrailSubmenus();

  submenuItems.forEach(function(submenuItem) {
    var linkOrStrong = submenuItem.querySelector("a, strong");
    if (linkOrStrong) {
      linkOrStrong.addEventListener("click", function(event) {
        if (isTouch || null !== togglerElement.offsetParent || submenuItem.parentNode.classList.contains("level_2")) {
          Array.from(submenuItem.parentNode.children).forEach(sibling => {
            if (sibling !== submenuItem && sibling.classList.contains("submenu")) {
              sibling.classList.remove("submenu--active");
              let nestedActiveSubmenu = sibling.querySelector(".submenu--active");
              if (nestedActiveSubmenu) {
                nestedActiveSubmenu.classList.remove("submenu--active");
              }
              sibling.querySelectorAll("ul").forEach(ulElement => {
                ulElement.style.maxHeight = "";
              });
            }
          });

          if (!submenuItem.classList.contains("submenu--active")) {
            if (submenuItem.querySelector("ul")) {
              event.preventDefault();
            }
            submenuItem.classList.add("submenu--active");
            let ulToOpen = submenuItem.querySelector("ul");
            if (ulToOpen) {
              ulToOpen.style.maxHeight = ulToOpen.scrollHeight + "px";
            }
          } else {
            if (event.target.tagName === 'STRONG' && submenuItem.classList.contains("submenu--active")) {
                 submenuItem.classList.remove("submenu--active");
                 let ulToClose = submenuItem.querySelector("ul");
                 if (ulToClose) {
                   ulToClose.style.maxHeight = "";
                 }
            } else if (!submenuItem.querySelector("ul")) {
                // Kein Submenü, Link normal folgen
            } else if (event.target.tagName === 'A' && !submenuItem.querySelector("ul a[href='" + event.target.getAttribute('href') + "'] ul")) {
                // Link geklickt, der kein weiteres Submenü direkt aufklappt
            } else if (submenuItem.querySelector("ul")) {
                 event.preventDefault();
                 submenuItem.classList.remove("submenu--active");
                 let ulToClose = submenuItem.querySelector("ul");
                 if (ulToClose) {
                   ulToClose.style.maxHeight = "";
                 }
            }
          }
        }
      });
    }
  });

  mainNavElement.addEventListener("click", function(event) {
    if (mainNavElement.classList.contains("nav--mobile--active") && !mainNavElement.querySelector("ul").contains(event.target) && !togglerElement.contains(event.target) && event.target !== togglerElement) {
      mainNavElement.classList.remove("nav--mobile--active");
      togglerElement.classList.remove("navbar-toggler--active"); // Ersetzt
    }
  });

  window.addEventListener("resize", () => {
    toggleActiveTrailSubmenus();
  });
}

// Die Funktion ausführen, sobald das DOM vollständig geladen ist.
document.addEventListener('DOMContentLoaded', initializeNavMobile);


/*----------------------------------------
  Navbar Theme Toggler
----------------------------------------*/
// Theme-Toggle-Logik (für alle Seiten)
const themeToggle = document.getElementById('navbar-contrast-toggler');

// Funktion zum Aktivieren des Dark-Modes
function enableDarkMode() {
  document.documentElement.classList.add('dark-mode');
  if (themeToggle) {
    // themeToggle.textContent = 'Light-Mode';
    themeToggle.setAttribute('aria-label', 'Kontrast umschalten');
  }
  localStorage.setItem('darkMode', 'enabled');
}

// Funktion zum Deaktivieren des Dark-Modes
function disableDarkMode() {
  document.documentElement.classList.remove('dark-mode');
  if (themeToggle) {
    // themeToggle.textContent = 'Dark-Mode';
    themeToggle.setAttribute('aria-label', 'Kontrast umschalten');
  }
  localStorage.setItem('darkMode', 'disabled');
}

// Beim Laden jeder Seite prüfen, ob Dark-Mode aktiv ist
if (localStorage.getItem('darkMode') === 'enabled') {
  enableDarkMode();
} else {
  disableDarkMode(); // Explizit zurücksetzen (falls localStorage leer)
}

// Event-Listener nur hinzufügen, wenn der Button existiert
if (themeToggle) {
  themeToggle.addEventListener('click', () => {
    if (document.documentElement.classList.contains('dark-mode')) {
      disableDarkMode();
    } else {
      enableDarkMode();
    }
  });
}


/*----------------------------------------
  NavigationAccessibility I
----------------------------------------*/
